module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/twoPhones_1x.5879368.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/twoPhones_1x.png
// module id = fcFl
// module chunks = 41